import { formatDateTime } from '../../shared/utility/dateFormatter';

export const renderDate = (params) => (params.value ? formatDateTime(params.value) : '');

export const renderDateValue = (value) => (value ? formatDateTime(value) : '');
